<script>
export default {
  name: 'ChartsPlaceholder',
  beforeCreate() {
    window.location.href = window.location.origin + '/charts';
  }
}
</script>



// WEBPACK FOOTER //
// src/components/analyse/ChartsPlaceholder.vue